import { lazy, Suspense, useEffect, useState } from 'react';
import { useRoutes, useLocation } from 'react-router-dom';
import { routes } from './routes';

const ChatBot = lazy(() => import('./pages/ChatBot'));

function App() {
  const element = useRoutes(routes);
  const location = useLocation();
  const [showChat, setShowChat] = useState(false);
  const isLandingPage = location.pathname === '/lp' || location.pathname === '/lp/' || location.pathname.startsWith('/lp/');

  useEffect(() => {
    // Charge le chat seulement après la première interaction ou 4s
    // Pas de chat sur les landing pages (qui ont leur exit intent popup)
    if (isLandingPage) {
      setShowChat(false);
      return;
    }

    const load = () => setShowChat(true);
    const timer = setTimeout(load, 4000);
    window.addEventListener('scroll', load, { once: true });
    window.addEventListener('mousemove', load, { once: true });
    window.addEventListener('touchstart', load, { once: true });
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', load);
      window.removeEventListener('mousemove', load);
      window.removeEventListener('touchstart', load);
    };
  }, [isLandingPage]);

  return (
    <>
      {element}
      {showChat && (
        <Suspense fallback={null}>
          <ChatBot />
        </Suspense>
      )}
    </>
  );
}

export default App;